export default __webpack_public_path__ + "static/media/about.3cce0b91.svg";